<template>
  <div>
    <div class="weather-info">
      <strong> ☀️ Sol com algumas nuvens</strong><br />
      <span>Temperatura: 28º</span><br />
      <span>Chuva: 0% | Ventos: 10% | Umidade: 10%</span>
    </div>

    <!-- Mapa -->
    <div class="map-container">
      <div
        id="mapa"
        style="
          width: 1150px;
          height: 1100px;
          top: 10px;
          left: 300px;
          border-radius: 25px;
          z-index: 0;
        "
      ></div>

      <!-- Painel lateral -->
      <div class="painel-tour">
        <h2><strong>24.000</strong></h2>
        <p>Chegadas</p>

        <div class="numbers">
          <span>75%</span>
          <span>10%</span>
          <span>10%</span>
          <span>5%</span>
        </div>
        <div class="descriptions">
          <span>Rodoviário</span>
          <span>Ferroviário</span>
          <span>Aéreo</span>
          <span>Marítimo</span>
        </div>
      </div>

      <!-- Painel lateral modais-->
      <div class="componentPanel">
        <h2><strong>Modais</strong></h2>
        <p style="color: blue; margin-top: 20px">Aeroviário</p>
        <p class="consulta-info" style="font-size: 12px">
          Aeroporto internacional de Foz do Iguaçu
        </p>

        <p style="color: red; margin-top: 20px">Rodoviário</p>
        <p class="consulta-info" style="font-size: 12px">
          Rodoviária internacional de Foz do Iguaçu
        </p>

        <p style="color: green; margin-top: 20px">BR 409</p>
        <p class="consulta-info" style="font-size: 12px">BR</p>

        <p style="color: peru; margin-top: 20px">Ferroviário</p>
        <p class="consulta-info" style="font-size: 12px">Estação de Foz do Iguaçu</p>

        <p style="color: slateblue; margin-top: 20px">Marítimo</p>
        <p class="consulta-info" style="font-size: 12px">Porto de Foz do Iguaçu</p>
      </div>
      <!-- Painel lateral origem -->

      <div class="panel-origin">
        <h2><strong>Origem</strong></h2>
        <p class="brasil">
          Brasil <span class="quantidade">2.000</span> <span class="percentual">30%</span>
        </p>
        <p class="uruguai">
          Uruguai <span class="quantidade">200</span> <span class="percentual">10%</span>
        </p>
        <p class="argentina">
          Argentina <span class="quantidade">150</span> <span class="percentual">5%</span>
        </p>
        <p class="paraguai">
          Paraguai <span class="quantidade">280</span> <span class="percentual">30%</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from './Layout.vue'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'

export default {
  name: 'Modais',
  layout: Layout,
  data() {
    return {
      tela: 'mapa',
    }
  },
  methods: {
    hoverWord(event) {},
    leaveWord(event) {},
    selectButton(button) {
      this.selectedButton = button
    },
  },

  mounted() {
    // Inicialização do mapa com vista mais ampla
    var mapa = L.map('mapa').setView([-25.5163, -54.5854], 13)

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(mapa)

    var customControl = L.control()

    customControl.onAdd = function (map) {
      var div = L.DomUtil.create('div', 'custom-control')
      div.style.textAlign = 'left'
      div.innerHTML = `
        <button class="map-button">Modais de Transporte</button>
        <button class="map-button">Tráfego</button>
        <button class="map-button">Clima</button>
      `
      return div
    }

    customControl.addTo(mapa)

    var mapIconControl = L.control({ position: 'bottomright' })
  },
}
</script>

<style>
.weather-info {
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
  padding: 30px;
  width: 1150px;
  margin-top: 140px;
  margin-left: 290px;
  text-align: center;
}
.weather-info strong {
  font-weight: bold;
  font-size: 20px;
}

.word-panel {
  position: absolute;
  top: 130px;
  right: 20px;
  display: flex;
  background-color: #e6e3e3;
  padding: 10px;
  border-radius: 10px;
}

.word {
  background-color: #e6e3e3;
  color: #000;
  padding: 5px 10px;
  margin-right: 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.word:hover {
  background-color: #fff;
  color: #000;
}
.temperature {
  margin-top: 50px;
  font-size: 14px;
  color: #555;
}
.text-container {
  margin-left: 240px;
}

.panel-title {
  font-weight: bold;
  font-size: 25px;
  color: #2e2c2c;
  margin-bottom: 40px;
  text-align: center;
  position: relative;
}

.welcome-bar {
  display: flex;
  align-items: center;
  background-color: rgb(255, 255, 255);
  color: #2e2c2c;
  padding: 25px 20px;
  border-radius: 18px;
  text-align: center;
  line-height: 30px;
  width: 1150px;
  margin: 40px auto 20px;
  margin-left: 300px;
}

.menu-item:hover::before {
  background-color: rgb(69, 142, 156);
}
.menu-item::before {
  content: '';
  position: absolute;
  top: -5px;
  left: 0;
  width: 100%;
  height: 5px;
  transition: background-color 0.5s;
  z-index: 5;
}

.painel-tour {
  position: absolute;
  top: 500px;
  right: 60px;
  width: 300px;
  height: 200px;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  font-size: 25px;
}

.componentPanel {
  position: absolute;
  top: 720px;
  right: 60px;
  width: 300px;
  height: 400px;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.panel-origin {
  position: absolute;
  top: 1130px;
  right: 60px;
  width: 300px;
  height: 300px;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.numbers,
.descriptions {
  display: flex;
  justify-content: space-around;
  width: 90%;
  font-size: 10px;
}

.numbers span,
.descriptions span {
  margin: 50 10px;
}

.numbers span {
  font-weight: bold;
  font-size: 18px;
}
.painel-tour .numbers {
  margin-top: 70px;
}
.panel-origin p {
  position: relative;
  padding-left: 20px;
  margin-top: 25px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
}

.panel-origin p::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 15px;
  height: 15px;
  border-radius: 50%;
}

.brasil::before {
  background-color: green;
}

.uruguai::before {
  background-color: blue;
}

.argentina::before {
  background-color: rgb(112, 173, 222);
}

.paraguai::before {
  background-color: red;
}
.quantidade,
.percentual {
  margin-left: 50px;
}

.menu-item {
  cursor: pointer;
  margin-bottom: 10px;
}
.search-box {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 300px;
  height: 40px;
}

.search-box input[type='text'] {
  width: 100%;
  height: 100%;
  padding: 10px 20px 10px 40px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 10px;
}

.search-box .icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 20px;
  color: #ccc;
}
.export-button {
  background-color: #50acba;
  color: #fff;
  border: none;
  padding: 15px 25px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
  position: absolute;
  top: 180px;
  right: 20px;
}
.search-wrapper {
  position: absolute;
  right: 890px;
  top: 210px;
  width: 300px;
  height: 40px;
}

.search-wrapper input[type='text'] {
  padding: 10px 20px 10px 40px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 10px;
}
.search-wrapper .icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 20px;
  color: #f4f1f1;
}
.real-time-data {
  display: flex;
  align-items: center;
  height: 200px;
  position: absolute;
  right: 890px;
  top: 180px;
  width: 300px;
  color: #2e2c2c;
}
.date-filter {
  display: flex;
}
.map-button {
  background-color: #f3e7e7;
  color: #000000;
  border: none;
  padding: 10px 20px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 15px;
  font-size: 15px;
}

.map-button:hover {
  background-color: #ffffff;
  color: #000000;
}
</style>
